var _defs, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g4, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogowhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 499.05 136.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-7{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#ffffff;}.cls-4{clip-path:url(#clip-path-2);}.cls-5{clip-path:url(#clip-path-3);}.cls-10,.cls-6{fill:#2dbe6c;}.cls-7{stroke:#2dbe6c;}.cls-8{clip-path:url(#clip-path-4);}.cls-9{clip-path:url(#clip-path-5);}.cls-10{fill-rule:evenodd;}.cls-11{clip-path:url(#clip-path-7);}.cls-12{clip-path:url(#clip-path-10);}.cls-13{clip-path:url(#clip-path-13);}.cls-14{clip-path:url(#clip-path-16);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-0.55 -0.78)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    className: "cls-1",
    x: -0.1,
    y: 0.75,
    width: 129.85,
    height: 57.16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-0.55 -0.78)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-2",
    "data-name": "SVGID",
    className: "cls-1",
    x: 12.31,
    y: 40.38,
    width: 33.46,
    height: 65.19
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-0.55 -0.78)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-3",
    "data-name": "SVGID",
    className: "cls-1",
    x: 40.99,
    y: 21.26,
    width: 79.67,
    height: 84.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(-0.55 -0.78)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-4",
    "data-name": "SVGID",
    className: "cls-1",
    x: 429.79,
    y: 29.23,
    width: 70.11,
    height: 49.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(-0.55 -0.78)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-5",
    "data-name": "SVGID",
    className: "cls-1",
    x: 442.34,
    y: 13.54,
    width: 41.7,
    height: 73.86,
    transform: "translate(231.68 454.81) rotate(-66.42)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(-0.55 -0.78)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-7",
    "data-name": "SVGID",
    className: "cls-1",
    x: 452.09,
    y: 43.57,
    width: 6.37,
    height: 11.15
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10",
    transform: "translate(-0.55 -0.78)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-10",
    "data-name": "SVGID",
    className: "cls-1",
    x: 464.84,
    y: 49.95,
    width: 7.97,
    height: 9.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13",
    transform: "translate(-0.55 -0.78)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-13",
    "data-name": "SVGID",
    className: "cls-1",
    x: 476,
    y: 61.1,
    width: 4.78,
    height: 6.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16",
    transform: "translate(-0.55 -0.78)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-16",
    "data-name": "SVGID",
    className: "cls-1",
    x: 440.94,
    y: 45.17,
    width: 3.19,
    height: 6.37
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.63,48,125,45.4,108.39,28.78l-.72-.72V11.88h-9V19.1L80.33.78,51.92,29.14,36.23,13.46,2,47.62a5,5,0,0,0,7.07,7.05l27.15-27.1,8.63,8.62L33.41,47.62a5,5,0,0,0,7.06,7.05L80.33,14.88,120.56,55A5,5,0,0,0,127.63,48",
    transform: "translate(-0.55 -0.78)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.15,101.91v-5H21.38V40.66H12.73V102a3.51,3.51,0,0,0,3.51,3.51H44.78a3.64,3.64,0,0,1-3.63-3.64",
    transform: "translate(-0.55 -0.78)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.48,85.88A10.3,10.3,0,0,1,84.19,96.15H77.52A10.29,10.29,0,0,1,67.24,85.88V60.32A10.27,10.27,0,0,1,77.52,50.07h6.67A10.28,10.28,0,0,1,94.48,60.32Zm25-26.15-36.07-36a3.63,3.63,0,0,0-5.14,0C39,62.94,41.15,60.22,41.15,62.3v39.61a3.64,3.64,0,0,0,3.63,3.64h72.27a3.51,3.51,0,0,0,3.51-3.51c0-43,.44-40.82-1.06-42.31",
    transform: "translate(-0.55 -0.78)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.86,76.06a3,3,0,1,1,3-3A3,3,0,0,1,80.86,76.06Zm3.33-19.54H77.52a3.8,3.8,0,0,0-3.8,3.8V85.88a3.8,3.8,0,0,0,3.8,3.8h6.67A3.81,3.81,0,0,0,88,85.88V60.32a3.81,3.81,0,0,0-3.81-3.8",
    transform: "translate(-0.55 -0.78)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.4,133.73V122.36h2.29v9.46h5.73v1.91Z",
    transform: "translate(-0.55 -0.78)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.37,131.12l2.19.35A3.5,3.5,0,0,1,47,133.93a3.77,3.77,0,0,1-3-1.14,5.27,5.27,0,0,1,.05-6.3,3.47,3.47,0,0,1,2.69-1.17,3.63,3.63,0,0,1,2.86,1.19,5.15,5.15,0,0,1,1,3.51v.23H45.2a2.19,2.19,0,0,0,.53,1.49,1.62,1.62,0,0,0,1.27.55A1.37,1.37,0,0,0,48.37,131.12Zm.12-2.22a2.14,2.14,0,0,0-.5-1.42,1.44,1.44,0,0,0-1.12-.49,1.51,1.51,0,0,0-1.17.52,1.94,1.94,0,0,0-.45,1.34v.05Z",
    transform: "translate(-0.55 -0.78)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.81,125.49v1.75H56.32v3.31c0,.66,0,1,0,1.17a.66.66,0,0,0,.2.3.74.74,0,0,0,.38.1,2.72,2.72,0,0,0,.87-.23l.2,1.69a4.26,4.26,0,0,1-1.74.35,2.58,2.58,0,0,1-1.22-.27,1.57,1.57,0,0,1-.73-.82,8.08,8.08,0,0,1-.17-2v-3.58h-1v-1.75h1v-1.64l2.19-1.27v2.91Z",
    transform: "translate(-0.55 -0.78)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.69,125.49v1.75H63.2v3.31c0,.66,0,1,0,1.17a.59.59,0,0,0,.2.3.7.7,0,0,0,.37.1,2.66,2.66,0,0,0,.87-.23l.2,1.69a4.19,4.19,0,0,1-1.74.35,2.61,2.61,0,0,1-1.22-.27,1.55,1.55,0,0,1-.72-.82,7.49,7.49,0,0,1-.18-2v-3.58H60v-1.75h1v-1.64l2.2-1.27v2.91Z",
    transform: "translate(-0.55 -0.78)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.78,124.37v-2H70v2Zm0,9.36v-8.24H70v8.24Z",
    transform: "translate(-0.55 -0.78)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.25,133.73H79.08v-4.2a5.91,5.91,0,0,0-.15-1.72,1.08,1.08,0,0,0-.44-.6,1.21,1.21,0,0,0-.75-.22,1.79,1.79,0,0,0-1,.32,1.5,1.5,0,0,0-.62.82A7.7,7.7,0,0,0,76,130v3.73H73.76v-8.24h2v1.22a3.38,3.38,0,0,1,2.74-1.39,3.53,3.53,0,0,1,1.32.25,2.05,2.05,0,0,1,.9.67,2.25,2.25,0,0,1,.4.92,6.77,6.77,0,0,1,.12,1.47Z",
    transform: "translate(-0.55 -0.78)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.87,134.28l2.49.3a.8.8,0,0,0,.37.65,1.83,1.83,0,0,0,.87.17,3.08,3.08,0,0,0,1.07-.15,1,1,0,0,0,.6-.52,2.79,2.79,0,0,0,.18-1.12v-1.22a3.08,3.08,0,0,1-4.93.2,4.58,4.58,0,0,1-1-3,4.48,4.48,0,0,1,1-3.17,3.27,3.27,0,0,1,2.49-1.09,3,3,0,0,1,2.51,1.34v-1.17h2v7.4a6.31,6.31,0,0,1-.4,2.56A2.42,2.42,0,0,1,91,136.67a5.63,5.63,0,0,1-2.27.4,4.7,4.7,0,0,1-3-.72,2.2,2.2,0,0,1-.87-1.82Zm1.94-4.83a2.94,2.94,0,0,0,.5,1.92,1.59,1.59,0,0,0,1.24.6,1.73,1.73,0,0,0,1.37-.63,2.71,2.71,0,0,0,.55-1.84,2.88,2.88,0,0,0-.52-1.89A1.7,1.7,0,0,0,88.6,127a1.67,1.67,0,0,0-1.29.59A2.84,2.84,0,0,0,86.81,129.45Z",
    transform: "translate(-0.55 -0.78)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.58,131.39l2.19-.35a1.58,1.58,0,0,0,1.77,1.32,2.4,2.4,0,0,0,1.12-.22.78.78,0,0,0,.43-.7.54.54,0,0,0-.18-.4,1.58,1.58,0,0,0-.72-.27,11.93,11.93,0,0,1-3.34-1.07,2.17,2.17,0,0,1-1-1.87,2.22,2.22,0,0,1,.85-1.76,3.89,3.89,0,0,1,2.64-.75,4.51,4.51,0,0,1,2.49.55,2.71,2.71,0,0,1,1.14,1.61l-2.06.38c-.17-.66-.69-1-1.55-1s-1.49.24-1.49.7c0,.24.16.42.5.55s.92.27,1.76.47a6,6,0,0,1,2.42.95,2,2,0,0,1,.7,1.64,2.5,2.5,0,0,1-1,1.94,4.13,4.13,0,0,1-2.79.82,4.72,4.72,0,0,1-2.69-.67A3.2,3.2,0,0,1,95.58,131.39Z",
    transform: "translate(-0.55 -0.78)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113,137.07V122.18h1.72v14.89Z",
    transform: "translate(-0.55 -0.78)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.88,133.73V122.36h2.29v9.46h5.73v1.91Z",
    transform: "translate(-0.55 -0.78)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.71,128l-2-.35a3.07,3.07,0,0,1,1.12-1.77,4.29,4.29,0,0,1,2.44-.57,5.15,5.15,0,0,1,2.17.35,2.07,2.07,0,0,1,1,.87,4.29,4.29,0,0,1,.3,1.94l0,2.56a9,9,0,0,0,.1,1.6,4.06,4.06,0,0,0,.4,1.09H141.1a3.55,3.55,0,0,1-.18-.49,2.5,2.5,0,0,1-.1-.4,3.61,3.61,0,0,1-2.56,1.09,2.86,2.86,0,0,1-2-.69,2.34,2.34,0,0,1-.72-1.77,2.25,2.25,0,0,1,.32-1.22,2.37,2.37,0,0,1,.95-.85,7.17,7.17,0,0,1,1.74-.52,11.14,11.14,0,0,0,2.09-.52v-.23a1.06,1.06,0,0,0-.32-.87,1.79,1.79,0,0,0-1.15-.27,1.58,1.58,0,0,0-.92.22A1.53,1.53,0,0,0,137.71,128Zm2.91,1.76a10.34,10.34,0,0,1-1.32.35,3.2,3.2,0,0,0-1.17.38.9.9,0,0,0-.45.77,1.11,1.11,0,0,0,.35.8,1.26,1.26,0,0,0,.87.32,1.66,1.66,0,0,0,.7-.15,1.81,1.81,0,0,0,.57-.37,1.27,1.27,0,0,0,.35-.5,4.72,4.72,0,0,0,.1-1.17Z",
    transform: "translate(-0.55 -0.78)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154,133.73h-2.17v-4.2a5.91,5.91,0,0,0-.15-1.72,1.08,1.08,0,0,0-.44-.6,1.21,1.21,0,0,0-.75-.22,1.79,1.79,0,0,0-1,.32,1.5,1.5,0,0,0-.62.82,7.7,7.7,0,0,0-.15,1.87v3.73h-2.2v-8.24h2v1.22a3.37,3.37,0,0,1,2.74-1.39,3.53,3.53,0,0,1,1.32.25,2.05,2.05,0,0,1,.9.67,2.11,2.11,0,0,1,.39.92,6.08,6.08,0,0,1,.13,1.47Z",
    transform: "translate(-0.55 -0.78)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M165.34,133.73h-2v-1.22a3.36,3.36,0,0,1-1.19,1.07,3.06,3.06,0,0,1-1.4.35,3.18,3.18,0,0,1-2.44-1.14,4.74,4.74,0,0,1-1-3.21,4.57,4.57,0,0,1,1-3.17,3.27,3.27,0,0,1,2.51-1.09,3.12,3.12,0,0,1,2.39,1.14v-4.1h2.17Zm-5.8-4.3a3.51,3.51,0,0,0,.5,2.14,1.61,1.61,0,0,0,1.32.62,1.64,1.64,0,0,0,1.29-.62,3,3,0,0,0,.52-1.92,3.16,3.16,0,0,0-.52-2,1.58,1.58,0,0,0-1.29-.62,1.64,1.64,0,0,0-1.3.62A2.71,2.71,0,0,0,159.54,129.43Z",
    transform: "translate(-0.55 -0.78)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.08,133.73V122.36h2.17v11.37Z",
    transform: "translate(-0.55 -0.78)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.59,129.5a4.43,4.43,0,0,1,.52-2.09,3.47,3.47,0,0,1,1.49-1.54,4.46,4.46,0,0,1,2.22-.55,4.14,4.14,0,0,1,4.26,4.26,4.34,4.34,0,0,1-1.22,3.13,4,4,0,0,1-3,1.22,4.83,4.83,0,0,1-2.19-.52,3.58,3.58,0,0,1-1.54-1.49A5.12,5.12,0,0,1,174.59,129.5Zm2.24.13a2.67,2.67,0,0,0,.57,1.86,1.81,1.81,0,0,0,1.44.65,1.79,1.79,0,0,0,1.4-.65,2.68,2.68,0,0,0,.59-1.89,2.59,2.59,0,0,0-.59-1.84,1.78,1.78,0,0,0-1.4-.67,1.8,1.8,0,0,0-1.44.67A2.7,2.7,0,0,0,176.83,129.63Z",
    transform: "translate(-0.55 -0.78)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M188.46,133.73h-2.19v-8.24h2v1.17a3.47,3.47,0,0,1,.92-1.07,1.75,1.75,0,0,1,1-.27,2.74,2.74,0,0,1,1.42.42l-.67,1.89a1.85,1.85,0,0,0-1-.37,1.19,1.19,0,0,0-.78.27,1.69,1.69,0,0,0-.49.93,12.76,12.76,0,0,0-.18,2.73Z",
    transform: "translate(-0.55 -0.78)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M201.68,133.73h-2v-1.22a3.47,3.47,0,0,1-1.2,1.07,3,3,0,0,1-1.39.35,3.15,3.15,0,0,1-2.44-1.14,4.69,4.69,0,0,1-1-3.21,4.57,4.57,0,0,1,1-3.17,3.28,3.28,0,0,1,2.52-1.09,3.15,3.15,0,0,1,2.39,1.14v-4.1h2.16Zm-5.8-4.3a3.51,3.51,0,0,0,.5,2.14,1.61,1.61,0,0,0,1.32.62,1.64,1.64,0,0,0,1.29-.62,3,3,0,0,0,.53-1.92,3.16,3.16,0,0,0-.53-2,1.58,1.58,0,0,0-1.29-.62,1.64,1.64,0,0,0-1.3.62A2.76,2.76,0,0,0,195.88,129.43Z",
    transform: "translate(-0.55 -0.78)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M204.65,131.39l2.19-.35a1.58,1.58,0,0,0,1.77,1.32,2.4,2.4,0,0,0,1.12-.22.78.78,0,0,0,.43-.7.54.54,0,0,0-.18-.4,1.58,1.58,0,0,0-.72-.27,11.93,11.93,0,0,1-3.34-1.07,2.17,2.17,0,0,1-1-1.87,2.22,2.22,0,0,1,.85-1.76,3.89,3.89,0,0,1,2.64-.75,4.51,4.51,0,0,1,2.49.55,2.71,2.71,0,0,1,1.14,1.61l-2.06.38c-.17-.66-.69-1-1.55-1s-1.49.24-1.49.7c0,.24.16.42.5.55s.92.27,1.76.47a6,6,0,0,1,2.42.95,2,2,0,0,1,.7,1.64,2.5,2.5,0,0,1-.95,1.94,4.13,4.13,0,0,1-2.79.82,4.72,4.72,0,0,1-2.69-.67A3.2,3.2,0,0,1,204.65,131.39Z",
    transform: "translate(-0.55 -0.78)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M222.07,137.07V122.18h1.72v14.89Z",
    transform: "translate(-0.55 -0.78)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M236.44,133.73v-9.46h-3.39v-1.91h9v1.91h-3.36v9.46Z",
    transform: "translate(-0.55 -0.78)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M249.92,131.12l2.19.35a3.5,3.5,0,0,1-3.59,2.46,3.77,3.77,0,0,1-3-1.14,5.27,5.27,0,0,1,.05-6.3,3.49,3.49,0,0,1,2.69-1.17,3.63,3.63,0,0,1,2.86,1.19,5.15,5.15,0,0,1,1.05,3.51v.23h-5.46a2.19,2.19,0,0,0,.53,1.49,1.62,1.62,0,0,0,1.27.55A1.37,1.37,0,0,0,249.92,131.12Zm.12-2.22a2.14,2.14,0,0,0-.5-1.42,1.44,1.44,0,0,0-1.12-.49,1.51,1.51,0,0,0-1.17.52,1.94,1.94,0,0,0-.45,1.34v.05Z",
    transform: "translate(-0.55 -0.78)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M263.05,133.73h-2.17v-4.2a5.91,5.91,0,0,0-.15-1.72,1.08,1.08,0,0,0-.44-.6,1.21,1.21,0,0,0-.75-.22,1.79,1.79,0,0,0-1,.32,1.5,1.5,0,0,0-.62.82,7.7,7.7,0,0,0-.15,1.87v3.73h-2.2v-8.24h2v1.22a3.37,3.37,0,0,1,2.74-1.39,3.53,3.53,0,0,1,1.32.25,2.05,2.05,0,0,1,.9.67,2.11,2.11,0,0,1,.39.92,6.08,6.08,0,0,1,.13,1.47Z",
    transform: "translate(-0.55 -0.78)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M268.49,128l-2-.35a3,3,0,0,1,1.12-1.77,4.29,4.29,0,0,1,2.44-.57,5.07,5.07,0,0,1,2.16.35,2.1,2.1,0,0,1,1,.87,4.48,4.48,0,0,1,.29,1.94l-.05,2.56a10,10,0,0,0,.1,1.6,4.43,4.43,0,0,0,.4,1.09h-2.14a3.77,3.77,0,0,1-.17-.49,2.5,2.5,0,0,1-.1-.4,3.64,3.64,0,0,1-2.57,1.09,2.84,2.84,0,0,1-2-.69,2.35,2.35,0,0,1-.73-1.77,2.25,2.25,0,0,1,.33-1.22,2.41,2.41,0,0,1,.94-.85,7.13,7.13,0,0,1,1.75-.52,11.36,11.36,0,0,0,2.09-.52v-.23a1,1,0,0,0-.33-.87,1.74,1.74,0,0,0-1.14-.27,1.58,1.58,0,0,0-.92.22A1.53,1.53,0,0,0,268.49,128Zm2.91,1.76a10.34,10.34,0,0,1-1.32.35,3.13,3.13,0,0,0-1.17.38.9.9,0,0,0-.45.77,1.07,1.07,0,0,0,.35.8,1.24,1.24,0,0,0,.87.32,1.66,1.66,0,0,0,.7-.15,1.81,1.81,0,0,0,.57-.37,1.38,1.38,0,0,0,.35-.5,4.72,4.72,0,0,0,.1-1.17Z",
    transform: "translate(-0.55 -0.78)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.75,133.73h-2.16v-4.2a5.91,5.91,0,0,0-.15-1.72,1.15,1.15,0,0,0-.45-.6,1.21,1.21,0,0,0-.75-.22,1.81,1.81,0,0,0-1,.32,1.5,1.5,0,0,0-.62.82,7.7,7.7,0,0,0-.15,1.87v3.73h-2.19v-8.24h2v1.22a3.37,3.37,0,0,1,2.74-1.39,3.53,3.53,0,0,1,1.32.25,2.08,2.08,0,0,1,.89.67,2.25,2.25,0,0,1,.4.92,6.77,6.77,0,0,1,.12,1.47Z",
    transform: "translate(-0.55 -0.78)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M292.36,125.49v1.75h-1.5v3.31q0,1,0,1.17a.59.59,0,0,0,.2.3.7.7,0,0,0,.37.1,2.66,2.66,0,0,0,.87-.23l.2,1.69a4.22,4.22,0,0,1-1.74.35,2.61,2.61,0,0,1-1.22-.27,1.55,1.55,0,0,1-.72-.82,7.49,7.49,0,0,1-.18-2v-3.58h-1v-1.75h1v-1.64l2.19-1.27v2.91Z",
    transform: "translate(-0.55 -0.78)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M294.68,131.39l2.19-.35a1.57,1.57,0,0,0,1.77,1.32,2.43,2.43,0,0,0,1.12-.22.77.77,0,0,0,.42-.7.5.5,0,0,0-.18-.4,1.53,1.53,0,0,0-.72-.27A11.82,11.82,0,0,1,296,129.7a2.14,2.14,0,0,1-1-1.87,2.24,2.24,0,0,1,.84-1.76,3.91,3.91,0,0,1,2.64-.75,4.51,4.51,0,0,1,2.49.55,2.72,2.72,0,0,1,1.15,1.61l-2.07.38a1.38,1.38,0,0,0-1.54-1c-1,0-1.5.24-1.5.7,0,.24.16.42.5.55s.92.27,1.77.47a5.94,5.94,0,0,1,2.41.95,2,2,0,0,1,.7,1.64,2.5,2.5,0,0,1-.95,1.94,4.12,4.12,0,0,1-2.78.82,4.7,4.7,0,0,1-2.69-.67A3.16,3.16,0,0,1,294.68,131.39Z",
    transform: "translate(-0.55 -0.78)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M312.09,137.07V122.18h1.72v14.89Z",
    transform: "translate(-0.55 -0.78)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M323.92,133.73V122.36h4.81a8.08,8.08,0,0,1,2.66.32,2.64,2.64,0,0,1,1.32,1.09,3.09,3.09,0,0,1,.52,1.77,3,3,0,0,1-.77,2.12,3.63,3.63,0,0,1-2.24,1,5.39,5.39,0,0,1,1.22,1,11.68,11.68,0,0,1,1.3,1.84l1.39,2.21h-2.74l-1.67-2.46a18.57,18.57,0,0,0-1.19-1.67,1.69,1.69,0,0,0-.7-.5,4,4,0,0,0-1.14-.12h-.48v4.75Zm2.29-6.57h1.7A10.11,10.11,0,0,0,330,127a1.25,1.25,0,0,0,.62-.48,1.42,1.42,0,0,0,.25-.87,1.38,1.38,0,0,0-.3-.92,1.43,1.43,0,0,0-.87-.45,15.64,15.64,0,0,0-1.66,0h-1.8Z",
    transform: "translate(-0.55 -0.78)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M341.71,131.12l2.19.35a3.49,3.49,0,0,1-3.59,2.46,3.77,3.77,0,0,1-3-1.14,5.27,5.27,0,0,1,0-6.3,3.49,3.49,0,0,1,2.69-1.17,3.61,3.61,0,0,1,2.86,1.19A5.15,5.15,0,0,1,344,130v.23h-5.45a2.14,2.14,0,0,0,.52,1.49,1.62,1.62,0,0,0,1.27.55A1.36,1.36,0,0,0,341.71,131.12Zm.12-2.22a2.09,2.09,0,0,0-.5-1.42,1.43,1.43,0,0,0-1.12-.49,1.51,1.51,0,0,0-1.17.52,1.93,1.93,0,0,0-.44,1.34v.05Z",
    transform: "translate(-0.55 -0.78)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M346.42,125.49h1.2v-.62a4,4,0,0,1,.22-1.54,1.82,1.82,0,0,1,.8-.83,3.23,3.23,0,0,1,1.52-.32,6.32,6.32,0,0,1,1.82.27l-.28,1.5a4.83,4.83,0,0,0-1-.13.85.85,0,0,0-.67.23,1.32,1.32,0,0,0-.2.87v.57h1.62v1.72h-1.62v6.52h-2.19v-6.52h-1.2Z",
    transform: "translate(-0.55 -0.78)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M359.67,133.73v-1.24a3.32,3.32,0,0,1-1.22,1.07,3.24,3.24,0,0,1-1.51.37,3,3,0,0,1-1.5-.37,2.2,2.2,0,0,1-.94-1,4.54,4.54,0,0,1-.3-1.82v-5.23h2.16v3.79a9.61,9.61,0,0,0,.13,2.14,1.21,1.21,0,0,0,.45.62,1.32,1.32,0,0,0,.79.22,1.78,1.78,0,0,0,1-.29,1.45,1.45,0,0,0,.6-.75,8.83,8.83,0,0,0,.17-2.24v-3.49h2.19v8.24Z",
    transform: "translate(-0.55 -0.78)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M367.63,133.73h-2.2v-8.24h2v1.17a3.47,3.47,0,0,1,.92-1.07,1.77,1.77,0,0,1,1-.27,2.71,2.71,0,0,1,1.42.42l-.67,1.89a1.85,1.85,0,0,0-1-.37,1.15,1.15,0,0,0-.77.27,1.63,1.63,0,0,0-.5.93,13,13,0,0,0-.17,2.73Z",
    transform: "translate(-0.55 -0.78)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M373.2,133.73V122.36h2.19v4.1a3.06,3.06,0,0,1,2.39-1.14,3.19,3.19,0,0,1,2.47,1.09,4.46,4.46,0,0,1,1,3.12,4.74,4.74,0,0,1-1,3.26,3.12,3.12,0,0,1-2.44,1.14,3,3,0,0,1-1.37-.35,3.73,3.73,0,0,1-1.19-1.07v1.22Zm2.17-4.3a3.44,3.44,0,0,0,.52,2.09,1.68,1.68,0,0,0,1.37.67,1.54,1.54,0,0,0,1.24-.6,3,3,0,0,0,.53-1.94,3.16,3.16,0,0,0-.53-2,1.65,1.65,0,0,0-1.31-.62,1.68,1.68,0,0,0-1.3.59A2.76,2.76,0,0,0,375.37,129.43Z",
    transform: "translate(-0.55 -0.78)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M384.59,124.37v-2h2.16v2Zm0,9.36v-8.24h2.16v8.24Z",
    transform: "translate(-0.55 -0.78)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.82,131.39,392,131a1.57,1.57,0,0,0,1.76,1.32,2.44,2.44,0,0,0,1.13-.22.77.77,0,0,0,.42-.7.5.5,0,0,0-.18-.4,1.53,1.53,0,0,0-.72-.27,11.82,11.82,0,0,1-3.33-1.07,2.15,2.15,0,0,1-1-1.87,2.22,2.22,0,0,1,.85-1.76,3.91,3.91,0,0,1,2.64-.75,4.51,4.51,0,0,1,2.49.55,2.72,2.72,0,0,1,1.15,1.61l-2.07.38a1.38,1.38,0,0,0-1.54-1c-1,0-1.5.24-1.5.7,0,.24.16.42.5.55s.92.27,1.77.47a5.94,5.94,0,0,1,2.41.95,2,2,0,0,1,.7,1.64,2.5,2.5,0,0,1-.95,1.94,4.13,4.13,0,0,1-2.79.82,4.68,4.68,0,0,1-2.68-.67A3.16,3.16,0,0,1,389.82,131.39Z",
    transform: "translate(-0.55 -0.78)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M403.17,122.36v4.18a3.21,3.21,0,0,1,2.52-1.22,3.32,3.32,0,0,1,1.37.27,2.18,2.18,0,0,1,.89.72,2.5,2.5,0,0,1,.4,1,7.93,7.93,0,0,1,.13,1.64v4.83h-2.17v-4.35a6.47,6.47,0,0,0-.12-1.62,1,1,0,0,0-.43-.57,1.43,1.43,0,0,0-.79-.2,1.78,1.78,0,0,0-1,.27,1.49,1.49,0,0,0-.62.8,4.37,4.37,0,0,0-.2,1.54v4.13H401V122.36Z",
    transform: "translate(-0.55 -0.78)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M412.14,125.49h2v1.12a3.21,3.21,0,0,1,2.56-1.29,2.52,2.52,0,0,1,2.34,1.29,3.16,3.16,0,0,1,2.49-1.29,3,3,0,0,1,1.44.32,2.06,2.06,0,0,1,.95.92,4.31,4.31,0,0,1,.32,1.9v5.27h-2.19V129a3,3,0,0,0-.3-1.67,1,1,0,0,0-.84-.37,1.49,1.49,0,0,0-.87.27,1.56,1.56,0,0,0-.58.82,6.38,6.38,0,0,0-.17,1.69v4H417.1v-4.5a5.65,5.65,0,0,0-.13-1.57.81.81,0,0,0-.34-.5A1.15,1.15,0,0,0,416,127a1.53,1.53,0,0,0-.89.27,1.4,1.4,0,0,0-.58.77,6.06,6.06,0,0,0-.17,1.7v4h-2.17Z",
    transform: "translate(-0.55 -0.78)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M432.76,131.12l2.19.35a3.5,3.5,0,0,1-3.59,2.46,3.77,3.77,0,0,1-3-1.14,5.27,5.27,0,0,1,.05-6.3,3.47,3.47,0,0,1,2.69-1.17,3.64,3.64,0,0,1,2.86,1.19,5.15,5.15,0,0,1,1.05,3.51v.23h-5.46a2.19,2.19,0,0,0,.53,1.49,1.62,1.62,0,0,0,1.27.55A1.37,1.37,0,0,0,432.76,131.12Zm.12-2.22a2.14,2.14,0,0,0-.5-1.42,1.44,1.44,0,0,0-1.12-.49,1.49,1.49,0,0,0-1.17.52,1.94,1.94,0,0,0-.45,1.34v.05Z",
    transform: "translate(-0.55 -0.78)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M445.89,133.73h-2.17v-4.2a5.91,5.91,0,0,0-.15-1.72,1.05,1.05,0,0,0-.45-.6,1.16,1.16,0,0,0-.74-.22,1.79,1.79,0,0,0-1,.32,1.57,1.57,0,0,0-.63.82,7.7,7.7,0,0,0-.15,1.87v3.73h-2.19v-8.24h2v1.22a3.37,3.37,0,0,1,2.74-1.39,3.53,3.53,0,0,1,1.32.25,2.05,2.05,0,0,1,.9.67,2.23,2.23,0,0,1,.39.92,6.65,6.65,0,0,1,.13,1.47Z",
    transform: "translate(-0.55 -0.78)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M453.49,125.49v1.75H452v3.31c0,.66,0,1,0,1.17a.59.59,0,0,0,.2.3.7.7,0,0,0,.37.1,2.77,2.77,0,0,0,.88-.23l.19,1.69a4.19,4.19,0,0,1-1.74.35,2.61,2.61,0,0,1-1.22-.27,1.55,1.55,0,0,1-.72-.82,7.62,7.62,0,0,1-.17-2v-3.58h-1v-1.75h1v-1.64l2.19-1.27v2.91Z",
    transform: "translate(-0.55 -0.78)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M455.81,131.39,458,131a1.57,1.57,0,0,0,1.77,1.32,2.43,2.43,0,0,0,1.12-.22.77.77,0,0,0,.42-.7.53.53,0,0,0-.17-.4,1.58,1.58,0,0,0-.72-.27,11.81,11.81,0,0,1-3.34-1.07,2.14,2.14,0,0,1-1-1.87,2.22,2.22,0,0,1,.85-1.76,3.88,3.88,0,0,1,2.63-.75,4.48,4.48,0,0,1,2.49.55,2.72,2.72,0,0,1,1.15,1.61l-2.07.38c-.17-.66-.68-1-1.54-1s-1.49.24-1.49.7c0,.24.16.42.49.55s.92.27,1.77.47a6,6,0,0,1,2.42.95,2,2,0,0,1,.69,1.64,2.49,2.49,0,0,1-.94,1.94,4.17,4.17,0,0,1-2.79.82,4.72,4.72,0,0,1-2.69-.67A3.16,3.16,0,0,1,455.81,131.39Z",
    transform: "translate(-0.55 -0.78)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.19,60.38v8.84h2.86V92.34h-2.86v8.83h17.15V92.34h-2.85V69.22h2.85V60.45Z",
    transform: "translate(-0.55 -0.78)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.28,60.45l-15.81-.07v8.84h2.85V92.34h-2.85v8.83h17.14V92.34h-2.85V74.49l9,13.91h2.93l9.08-13.91V92.34h-3v8.83H208V92.34H205V69.22H208V60.45H192.19l-9,14.55Z",
    transform: "translate(-0.55 -0.78)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M235.65,101.17V92.34H233.3V87.26h10.61c6.92,0,12.39-5,12.39-13.47s-5.47-13.34-12.39-13.34H219v8.77h2.86V92.34H219v8.83ZM233.3,78.49V69.22h7.25a4.24,4.24,0,0,1,4.32,4.57,4.39,4.39,0,0,1-4.32,4.7Z",
    transform: "translate(-0.55 -0.78)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.1,60.45v8.77H270V92.34H267.1v8.83h34.37V89.1h-7.82l-.51,3.24H281.39V85.16H292.7V76.39H281.39V69.22h11.75l.51,3.17h7.82V60.45Z",
    transform: "translate(-0.55 -0.78)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M328.92,101.17V92.34h-2.36V83.89h2l10.29,17.28h10.67V92.34h-3.75l-5.9-9.53c4.06-1.71,6.73-5.33,6.73-10.61,0-7.43-5.46-11.75-12.39-11.75h-22v8.77h2.86V92.34h-2.86v8.83ZM326.56,77.6V69.22h4.38a4.19,4.19,0,1,1,0,8.38Z",
    transform: "translate(-0.55 -0.78)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M360.36,60.38v8.84h2.86V92.34h-2.86v8.83h17.15V92.34h-2.85V69.22h2.85V60.45Z",
    transform: "translate(-0.55 -0.78)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M404.83,60.45l-13.4,31.89h-3v8.83h18.23V92.34h-3.36l1.52-4.58h11.44l1.53,4.58h-3.31v8.83h18.23V92.34h-3.05l-13.4-31.89ZM407.5,80l3.11-9.27L413.66,80Z",
    transform: "translate(-0.55 -0.78)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M443.59,60.45v8.77h2.86V92.34h-2.86v8.83H478v-12h-7.82l-.51,3.18H457.88V69.22h2.86V60.45Z",
    transform: "translate(-0.55 -0.78)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M49.54,113.28h396.7",
    transform: "translate(-0.55 -0.78)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M499.6,59.36l-2.61.92-.24,1.31c-13.19,6-21.1,8.06-21.72,4.83.68-5.31,3.4-9.67,7.57-13.35l2.2-.06,2.13-3.9-4.1,1.72-.29,2.22a45.08,45.08,0,0,1-12,6.52c-4.17,1.35-5.24,1.32-5.37-3.71-.09-3.72,1.23-8.08,1.84-12.13l3.71-1.8.79-10.56-7.22,7.76,1.2,3.94c-2.54,3.2-4.84,7.13-7.64,9.6-3.76,3.33-4.52,2.55-6.37-1.41A45.3,45.3,0,0,1,448.13,38l1.44-1.72L448,32.14l-1.42,4.21L448.08,38c.14,5.56-1.21,10.52-4.64,14.63-2.79,1.73-6.63-5.49-11.23-19.21l.79-1.07-1.09-2.54-.74,2.67.91.92L435.13,61l.79-12.41.15.29c1.29,2.45,3.64,6.54,6.94,6.16a3.83,3.83,0,0,0,1.57-.55l.29-.19.23-.26a21.56,21.56,0,0,0,3.16-5.1,30.51,30.51,0,0,0,1.29,3.25c.82,1.76,1.84,4.06,3.9,4.62,2.22.61,4.3-1.14,5.85-2.51A32.28,32.28,0,0,0,463.83,49a31.75,31.75,0,0,0-.79,6.9c0,2.06.18,4.78,2.14,6s4.19.31,6-.29a30.85,30.85,0,0,0,3.26-1.26,21.46,21.46,0,0,0-1.59,5.78l0,.35.07.34a3.61,3.61,0,0,0,.66,1.53c2,2.68,6.56,1.62,9.23.9l.32-.09-7.74,8.42,21.46-15.92,1.29,0Z",
    transform: "translate(-0.55 -0.78)"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M455.54,49.87a28.56,28.56,0,0,0-.52,3.44,10.76,10.76,0,0,0,1.68-1.24c.39-2.6,1.2-5.39,1.31-7.87-1.88,1.91-3.48,4.67-5.29,6.8.21.43.48,1,.75,1.47A30.64,30.64,0,0,0,455.54,49.87Z",
    transform: "translate(-0.55 -0.78)"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M468.81,55.67a30.37,30.37,0,0,0-.5,3.29c.54-.13,1.13-.31,1.59-.45.33-2.78,1.27-5.83,1.39-8.51-1.74,1.76-3.23,4.24-4.87,6.28a11.84,11.84,0,0,0,.23,2.09A29.36,29.36,0,0,0,468.81,55.67Z",
    transform: "translate(-0.55 -0.78)"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M478,66.73a45.27,45.27,0,0,0,2.74-4.41,36.33,36.33,0,0,0-4.12,2.36c-.11.47-.2.94-.28,1.43.41-.22.81-.46,1.2-.7-.26.39-.52.79-.76,1.2A4.23,4.23,0,0,0,478,66.73Z",
    transform: "translate(-0.55 -0.78)"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M443.67,50.31a36.36,36.36,0,0,0-1.08-4.62,46.19,46.19,0,0,0-1.36,5,4,4,0,0,0,.91.81q.21-.69.36-1.38c.1.46.19.91.3,1.36C443.11,51.11,443.39,50.72,443.67,50.31Z",
    transform: "translate(-0.55 -0.78)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogowhite);
export default __webpack_public_path__ + "static/media/logowhite.e16f2f06c6bf179ae75002038bdb2b40.svg";
export { ForwardRef as ReactComponent };